module.exports = __webpack_public_path__ + "img/ja-jp.webp";